// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.study-tools-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  transition: background-color 0.3s ease;
}

.dark-mode .study-tools-container {
  background-color: #121212;
}

.study-tools-content {
  display: flex;
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  gap: 30px;
}

.study-tools-sidebar {
  width: 280px;
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: calc(100vh - 100px);
  position: sticky;
  top: 80px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  overflow-y: auto;
}

.dark-mode .study-tools-sidebar {
  background: #1e1e1e;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.user-welcome {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
  transition: border-color 0.3s ease;
}

.dark-mode .user-welcome {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.user-welcome .user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0066cc, #0099ff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.3);
}

.user-welcome h3 {
  margin: 0;
  font-size: 1.2rem;
  color: #333;
  transition: color 0.3s ease;
  font-weight: 600;
}

.dark-mode .user-welcome h3 {
  color: #f5f5f5;
}

.study-tools-nav {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #555;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
  font-weight: 500;
}

.dark-mode .nav-item {
  color: #aaa;
}

.nav-item:hover {
  background: rgba(0, 102, 204, 0.08);
  color: #0066cc;
}

.dark-mode .nav-item:hover {
  background: rgba(102, 204, 255, 0.08);
  color: #66ccff;
}

.nav-item.active {
  background: #0066cc;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.2);
  font-weight: 600;
}

.dark-mode .nav-item.active {
  background: #0066cc;
  color: white;
  box-shadow: 0 4px 10px rgba(0, 102, 204, 0.3);
}

.nav-item svg {
  font-size: 1.2rem;
}

.study-tools-main {
  flex: 1 1;
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  min-height: calc(100vh - 100px);
  transition: all 0.3s ease;
  overflow: hidden;
  min-width: 0; /* Prevents content from overflowing */
}

.dark-mode .study-tools-main {
  background: #1e1e1e;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* Dashboard Styles */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.dark-mode .stat-card {
  background: #2d2d2d;
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-card h3 {
  margin: 0 0 16px 0;
  color: #666;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
  font-weight: 600;
}

.dark-mode .stat-card h3 {
  color: #aaa;
}

.stat-value {
  font-size: 2.4rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
  transition: color 0.3s ease;
  line-height: 1.2;
}

.dark-mode .stat-value {
  color: #f5f5f5;
}

.stat-trend {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  margin-top: auto;
}

.trend-up {
  color: #28a745;
}

.trend-down {
  color: #dc3545;
}

/* Chart containers */
.chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  height: 300px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .chart-container {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.chart-header {
  margin-bottom: 20px;
}

.chart-header h3 {
  font-size: 1.2rem;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.dark-mode .chart-header h3 {
  color: #f5f5f5;
}

/* Task Manager Styles */
.task-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.task-item {
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
}

.dark-mode .task-item {
  background: #2d2d2d;
  border-color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.task-checkbox {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #ddd;
  cursor: pointer;
}

.task-checkbox.checked {
  background: #28a745;
  border-color: #28a745;
}

.task-content {
  flex: 1 1;
}

.task-title {
  margin: 0 0 5px 0;
  font-size: 1rem;
  color: #333;
  transition: color 0.3s ease;
}

.dark-mode .task-title {
  color: #f5f5f5;
}

.task-meta {
  display: flex;
  gap: 15px;
  font-size: 0.85rem;
  color: #666;
  transition: color 0.3s ease;
}

.dark-mode .task-meta {
  color: #999;
}

.task-priority {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
}

.priority-high {
  background: #ffebee;
  color: #dc3545;
}

.priority-medium {
  background: #fff3e0;
  color: #f57c00;
}

.priority-low {
  background: #e8f5e9;
  color: #28a745;
}

/* Priority colors for dark mode */
.dark-mode .priority-high {
  background: #3d2427;
  color: #ff4d4d;
}

.dark-mode .priority-medium {
  background: #3d2f1a;
  color: #ffa64d;
}

.dark-mode .priority-low {
  background: #1f3d1f;
  color: #4dff4d;
}

/* Pomodoro Timer Styles */
.pomodoro-container {
  text-align: center;
  padding: 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 650px;
  margin: 0 auto;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .pomodoro-container {
  background: #2d2d2d;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.05);
}

.pomodoro-container h2 {
  font-size: 1.6rem;
  color: #333;
  margin: 0 0 16px 0;
  transition: color 0.3s ease;
  font-weight: 600;
}

.dark-mode .pomodoro-container h2 {
  color: #f5f5f5;
}

.timer-display {
  font-size: 5.5rem;
  font-weight: 700;
  color: #0066cc;
  margin: 20px 0 40px;
  padding: 10px;
  text-shadow: 0 2px 4px rgba(0, 102, 204, 0.2);
  transition: all 0.3s ease;
  letter-spacing: 2px;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.dark-mode .timer-display {
  color: #66ccff;
  text-shadow: 0 2px 4px rgba(102, 204, 255, 0.2);
}

.timer-controls {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.timer-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.start-button {
  background: #0066cc;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.25);
}

.start-button:hover {
  background: #0052a3;
  box-shadow: 0 6px 12px rgba(0, 102, 204, 0.3);
  transform: translateY(-2px);
}

.pause-button {
  background: #f39c12;
  color: white;
  box-shadow: 0 4px 8px rgba(243, 156, 18, 0.25);
}

.pause-button:hover {
  background: #e67e22;
  box-shadow: 0 6px 12px rgba(243, 156, 18, 0.3);
  transform: translateY(-2px);
}

.reset-button {
  background: #e74c3c;
  color: white;
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.25);
}

.reset-button:hover {
  background: #c0392b;
  box-shadow: 0 6px 12px rgba(231, 76, 60, 0.3);
  transform: translateY(-2px);
}

.settings-button {
  background: #7f8c8d;
  color: white;
  box-shadow: 0 4px 8px rgba(127, 140, 141, 0.25);
}

.settings-button:hover {
  background: #6c7a7a;
  box-shadow: 0 6px 12px rgba(127, 140, 141, 0.3);
  transform: translateY(-2px);
}

.dark-mode .start-button {
  background: #0078e7;
  box-shadow: 0 4px 8px rgba(0, 120, 231, 0.35);
}

.dark-mode .pause-button {
  background: #f5a623;
  box-shadow: 0 4px 8px rgba(245, 166, 35, 0.35);
}

.dark-mode .reset-button {
  background: #e74c3c;
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.35);
}

.dark-mode .settings-button {
  background: #95a5a6;
  box-shadow: 0 4px 8px rgba(149, 165, 166, 0.35);
}

.timer-settings {
  background: #f8f9fa;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 30px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.dark-mode .timer-settings {
  background: #3d3d3d;
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
}

.timer-settings h3 {
  color: #333;
  margin: 0 0 20px 0;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: left;
}

.dark-mode .timer-settings h3 {
  color: #f5f5f5;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  text-align: left;
}

.setting-item {
  margin-bottom: 16px;
}

.setting-item label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 500;
  font-size: 0.95rem;
}

.dark-mode .setting-item label {
  color: #bbb;
}

.setting-item input {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  color: #333;
  transition: all 0.2s ease;
}

.dark-mode .setting-item input {
  background: #2d2d2d;
  border-color: #555;
  color: #f5f5f5;
}

.setting-item input:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
}

.dark-mode .setting-item input:focus {
  border-color: #66ccff;
  box-shadow: 0 0 0 3px rgba(102, 204, 255, 0.15);
}

.session-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.stat-item {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .stat-item {
  background: #3d3d3d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.stat-item h4 {
  color: #7f8c8d;
  font-size: 0.9rem;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.dark-mode .stat-item h4 {
  color: #bbb;
}

.stat-item p {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
}

.dark-mode .stat-item p {
  color: #f5f5f5;
}

/* Break indicators */
.break-indicator {
  background: #e74c3c;
  color: white;
  padding: 6px 16px;
  border-radius: 50px;
  display: inline-block;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 16px;
  box-shadow: 0 3px 6px rgba(231, 76, 60, 0.2);
}

.break-indicator.break {
  background: #27ae60;
  box-shadow: 0 3px 6px rgba(39, 174, 96, 0.2);
}

.dark-mode .break-indicator {
  box-shadow: 0 3px 6px rgba(231, 76, 60, 0.3);
}

.dark-mode .break-indicator.break {
  box-shadow: 0 3px 6px rgba(39, 174, 96, 0.3);
}

@media (max-width: 768px) {
  .timer-display {
    font-size: 4rem;
    margin: 16px 0 32px;
  }
  
  .timer-controls {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  
  .timer-button {
    width: 100%;
    max-width: 280px;
  }
  
  .session-stats {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .setting-item label {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .pomodoro-container {
    padding: 16px;
  }
  
  .timer-display {
    font-size: 3.5rem;
    margin: 12px 0 24px;
  }
  
  .pomodoro-container h2 {
    font-size: 1.4rem;
  }
  
  .timer-settings {
    padding: 16px;
  }
  
  .settings-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .stat-item p {
    font-size: 1.5rem;
  }
}

/* Subject Tracker Styles */
.subject-tracker {
  padding: 2rem;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.dark-mode .subject-tracker {
  background: #1e1e1e;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.subject-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.subject-header h2 {
  font-size: 2rem;
  color: #2c3e50;
  margin: 0;
  transition: color 0.3s ease;
}

.dark-mode .subject-header h2 {
  color: #f5f5f5;
}

.add-subject-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #0066cc;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}

.dark-mode .add-subject-button {
  background: #1a75ff;
}

.add-subject-button:hover {
  background: #0052a3;
}

.dark-mode .add-subject-button:hover {
  background: #0052a3;
}

.subject-overview {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.subject-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.subject-list {
  display: grid;
  gap: 1rem;
}

.subject-card {
  background: #fff;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.dark-mode .subject-card {
  background: #2d2d2d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.subject-name {
  font-size: 1.2rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
}

.dark-mode .subject-name {
  color: #f5f5f5;
}

.progress-bar {
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1rem;
  transition: background-color 0.3s ease;
}

.dark-mode .progress-bar {
  background: #404040;
}

.progress-fill {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.subject-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #7f8c8d;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.dark-mode .subject-meta {
  color: #a0a0a0;
}

.subject-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.action-button {
  padding: 0.5rem;
  background: none;
  border: none;
  color: #3498db;
  cursor: pointer;
  transition: color 0.3s ease;
}

.dark-mode .action-button {
  color: #5dade2;
}

.action-button:hover {
  color: #2980b9;
}

.dark-mode .action-button:hover {
  color: #3498db;
}

.subject-form {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.dark-mode .subject-form {
  background: #2d2d2d;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #2c3e50;
  transition: color 0.3s ease;
}

.dark-mode .form-group label {
  color: #f5f5f5;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #2c3e50;
  transition: all 0.3s ease;
}

.dark-mode .form-group input,
.dark-mode .form-group select {
  background: #1e1e1e;
  border-color: #444;
  color: #f5f5f5;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #0066cc;
  outline: none;
}

.dark-mode .form-group input:focus,
.dark-mode .form-group select:focus {
  border-color: #1a75ff;
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.submit-button,
.cancel-button {
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-button {
  background: #0066cc;
  color: white;
  border: none;
}

.dark-mode .submit-button {
  background: #1a75ff;
}

.submit-button:hover {
  background: #0052a3;
}

.cancel-button {
  background: none;
  border: 1px solid #ddd;
  color: #7f8c8d;
}

.dark-mode .cancel-button {
  border-color: #444;
  color: #a0a0a0;
}

.cancel-button:hover {
  background: #f8f9fa;
  border-color: #ccc;
}

.dark-mode .cancel-button:hover {
  background: #2d2d2d;
  border-color: #666;
}

/* Streak Tracker Styles */
.streak-calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  margin: 20px 0;
}

.calendar-day {
  aspect-ratio: 1;
  border-radius: 5px;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  color: #666;
}

.calendar-day.active {
  background: #28a745;
  color: white;
}

/* Analytics Styles */
.analytics-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.resource-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.resource-card {
  background: white;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #eee;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.dark-mode .resource-card {
  background: #2d2d2d;
  border-color: #333;
}

.resource-card:hover {
  transform: translateY(-5px);
}

.dark-mode .resource-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
}

/* Achievement Styles */
.achievement-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

.achievement-card {
  background: white;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #eee;
}

.dark-mode .achievement-card {
  background: #2d2d2d;
  border-color: #333;
}

.achievement-icon {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #ffc107;
}

.achievement-locked {
  opacity: 0.5;
}

/* Responsive Design */
@media (max-width: 992px) {
  .study-tools-content {
    flex-direction: column;
    padding: 16px;
  }
  
  .study-tools-sidebar {
    width: 100%;
    height: auto;
    position: static;
    margin-bottom: 20px;
  }
  
  .study-tools-main {
    min-height: auto;
    padding: 24px;
  }
}

@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .stat-card {
    padding: 20px;
  }
  
  .chart-container {
    padding: 20px;
    height: 250px;
  }
}

@media (max-width: 480px) {
  .study-tools-main {
    padding: 16px;
  }
  
  .stat-value {
    font-size: 2rem;
  }
  
  .user-welcome .user-avatar {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  
  .user-welcome h3 {
    font-size: 1.1rem;
  }
}

/* Study Calendar Styles (Assuming it's part of Dashboard) */
.study-calendar {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px; 
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .study-calendar {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.calendar-header h3 {
  font-size: 1.2rem;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.dark-mode .calendar-header h3 {
  color: #f5f5f5;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

.calendar-day {
  aspect-ratio: 1 / 0.8;
  background: #f8f9fa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: #666;
  transition: all 0.2s ease;
  padding: 4px;
}

.dark-mode .calendar-day {
  background: #3d3d3d;
  color: #aaa;
}

.day-number {
  font-weight: 600;
  margin-bottom: 4px;
}

.day-hours {
  font-size: 0.75rem;
  color: #888;
}

.dark-mode .day-hours {
  color: #999;
}

.calendar-day.studied {
  background: rgba(40, 167, 69, 0.15);
  border: 1px solid rgba(40, 167, 69, 0.3);
  color: #1e7e34;
}

.dark-mode .calendar-day.studied {
  background: rgba(46, 204, 113, 0.15);
  border: 1px solid rgba(46, 204, 113, 0.3);
  color: #2ecc71;
}

.calendar-day.studied .day-hours {
  color: #218838;
}

.dark-mode .calendar-day.studied .day-hours {
  color: #2ecc71;
} `, "",{"version":3,"sources":["webpack://./src/components/StudyTools/StudyTools.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,YAAY,EAAE,sCAAsC;AACtD;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".study-tools-container {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n  transition: background-color 0.3s ease;\n}\n\n.dark-mode .study-tools-container {\n  background-color: #121212;\n}\n\n.study-tools-content {\n  display: flex;\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n  gap: 30px;\n}\n\n.study-tools-sidebar {\n  width: 280px;\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  height: calc(100vh - 100px);\n  position: sticky;\n  top: 80px;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n  overflow-y: auto;\n}\n\n.dark-mode .study-tools-sidebar {\n  background: #1e1e1e;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.user-welcome {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  margin-bottom: 24px;\n  transition: border-color 0.3s ease;\n}\n\n.dark-mode .user-welcome {\n  border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n\n.user-welcome .user-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #0066cc, #0099ff);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.3);\n}\n\n.user-welcome h3 {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #333;\n  transition: color 0.3s ease;\n  font-weight: 600;\n}\n\n.dark-mode .user-welcome h3 {\n  color: #f5f5f5;\n}\n\n.study-tools-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: none;\n  border-radius: 12px;\n  background: transparent;\n  color: #555;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  width: 100%;\n  font-weight: 500;\n}\n\n.dark-mode .nav-item {\n  color: #aaa;\n}\n\n.nav-item:hover {\n  background: rgba(0, 102, 204, 0.08);\n  color: #0066cc;\n}\n\n.dark-mode .nav-item:hover {\n  background: rgba(102, 204, 255, 0.08);\n  color: #66ccff;\n}\n\n.nav-item.active {\n  background: #0066cc;\n  color: white;\n  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.2);\n  font-weight: 600;\n}\n\n.dark-mode .nav-item.active {\n  background: #0066cc;\n  color: white;\n  box-shadow: 0 4px 10px rgba(0, 102, 204, 0.3);\n}\n\n.nav-item svg {\n  font-size: 1.2rem;\n}\n\n.study-tools-main {\n  flex: 1;\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  min-height: calc(100vh - 100px);\n  transition: all 0.3s ease;\n  overflow: hidden;\n  min-width: 0; /* Prevents content from overflowing */\n}\n\n.dark-mode .study-tools-main {\n  background: #1e1e1e;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* Dashboard Styles */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.dark-mode .stat-card {\n  background: #2d2d2d;\n  border-color: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.stat-card h3 {\n  margin: 0 0 16px 0;\n  color: #666;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: color 0.3s ease;\n  font-weight: 600;\n}\n\n.dark-mode .stat-card h3 {\n  color: #aaa;\n}\n\n.stat-value {\n  font-size: 2.4rem;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 16px;\n  transition: color 0.3s ease;\n  line-height: 1.2;\n}\n\n.dark-mode .stat-value {\n  color: #f5f5f5;\n}\n\n.stat-trend {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.95rem;\n  margin-top: auto;\n}\n\n.trend-up {\n  color: #28a745;\n}\n\n.trend-down {\n  color: #dc3545;\n}\n\n/* Chart containers */\n.chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px;\n  height: 300px;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .chart-container {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.chart-header {\n  margin-bottom: 20px;\n}\n\n.chart-header h3 {\n  font-size: 1.2rem;\n  color: #333;\n  margin: 0;\n  font-weight: 600;\n}\n\n.dark-mode .chart-header h3 {\n  color: #f5f5f5;\n}\n\n/* Task Manager Styles */\n.task-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.task-item {\n  background: white;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  border: 1px solid #eee;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  transition: all 0.3s ease;\n}\n\n.dark-mode .task-item {\n  background: #2d2d2d;\n  border-color: #333;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.task-checkbox {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 2px solid #ddd;\n  cursor: pointer;\n}\n\n.task-checkbox.checked {\n  background: #28a745;\n  border-color: #28a745;\n}\n\n.task-content {\n  flex: 1;\n}\n\n.task-title {\n  margin: 0 0 5px 0;\n  font-size: 1rem;\n  color: #333;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .task-title {\n  color: #f5f5f5;\n}\n\n.task-meta {\n  display: flex;\n  gap: 15px;\n  font-size: 0.85rem;\n  color: #666;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .task-meta {\n  color: #999;\n}\n\n.task-priority {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n}\n\n.priority-high {\n  background: #ffebee;\n  color: #dc3545;\n}\n\n.priority-medium {\n  background: #fff3e0;\n  color: #f57c00;\n}\n\n.priority-low {\n  background: #e8f5e9;\n  color: #28a745;\n}\n\n/* Priority colors for dark mode */\n.dark-mode .priority-high {\n  background: #3d2427;\n  color: #ff4d4d;\n}\n\n.dark-mode .priority-medium {\n  background: #3d2f1a;\n  color: #ffa64d;\n}\n\n.dark-mode .priority-low {\n  background: #1f3d1f;\n  color: #4dff4d;\n}\n\n/* Pomodoro Timer Styles */\n.pomodoro-container {\n  text-align: center;\n  padding: 20px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  max-width: 650px;\n  margin: 0 auto;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .pomodoro-container {\n  background: #2d2d2d;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.pomodoro-container h2 {\n  font-size: 1.6rem;\n  color: #333;\n  margin: 0 0 16px 0;\n  transition: color 0.3s ease;\n  font-weight: 600;\n}\n\n.dark-mode .pomodoro-container h2 {\n  color: #f5f5f5;\n}\n\n.timer-display {\n  font-size: 5.5rem;\n  font-weight: 700;\n  color: #0066cc;\n  margin: 20px 0 40px;\n  padding: 10px;\n  text-shadow: 0 2px 4px rgba(0, 102, 204, 0.2);\n  transition: all 0.3s ease;\n  letter-spacing: 2px;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.dark-mode .timer-display {\n  color: #66ccff;\n  text-shadow: 0 2px 4px rgba(102, 204, 255, 0.2);\n}\n\n.timer-controls {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-bottom: 40px;\n  flex-wrap: wrap;\n}\n\n.timer-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.start-button {\n  background: #0066cc;\n  color: white;\n  box-shadow: 0 4px 8px rgba(0, 102, 204, 0.25);\n}\n\n.start-button:hover {\n  background: #0052a3;\n  box-shadow: 0 6px 12px rgba(0, 102, 204, 0.3);\n  transform: translateY(-2px);\n}\n\n.pause-button {\n  background: #f39c12;\n  color: white;\n  box-shadow: 0 4px 8px rgba(243, 156, 18, 0.25);\n}\n\n.pause-button:hover {\n  background: #e67e22;\n  box-shadow: 0 6px 12px rgba(243, 156, 18, 0.3);\n  transform: translateY(-2px);\n}\n\n.reset-button {\n  background: #e74c3c;\n  color: white;\n  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.25);\n}\n\n.reset-button:hover {\n  background: #c0392b;\n  box-shadow: 0 6px 12px rgba(231, 76, 60, 0.3);\n  transform: translateY(-2px);\n}\n\n.settings-button {\n  background: #7f8c8d;\n  color: white;\n  box-shadow: 0 4px 8px rgba(127, 140, 141, 0.25);\n}\n\n.settings-button:hover {\n  background: #6c7a7a;\n  box-shadow: 0 6px 12px rgba(127, 140, 141, 0.3);\n  transform: translateY(-2px);\n}\n\n.dark-mode .start-button {\n  background: #0078e7;\n  box-shadow: 0 4px 8px rgba(0, 120, 231, 0.35);\n}\n\n.dark-mode .pause-button {\n  background: #f5a623;\n  box-shadow: 0 4px 8px rgba(245, 166, 35, 0.35);\n}\n\n.dark-mode .reset-button {\n  background: #e74c3c;\n  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.35);\n}\n\n.dark-mode .settings-button {\n  background: #95a5a6;\n  box-shadow: 0 4px 8px rgba(149, 165, 166, 0.35);\n}\n\n.timer-settings {\n  background: #f8f9fa;\n  padding: 24px;\n  border-radius: 12px;\n  margin-bottom: 30px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.03);\n  transition: all 0.3s ease;\n}\n\n.dark-mode .timer-settings {\n  background: #3d3d3d;\n  border-color: rgba(255, 255, 255, 0.05);\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.timer-settings h3 {\n  color: #333;\n  margin: 0 0 20px 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  text-align: left;\n}\n\n.dark-mode .timer-settings h3 {\n  color: #f5f5f5;\n}\n\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  text-align: left;\n}\n\n.setting-item {\n  margin-bottom: 16px;\n}\n\n.setting-item label {\n  display: block;\n  margin-bottom: 8px;\n  color: #555;\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.dark-mode .setting-item label {\n  color: #bbb;\n}\n\n.setting-item input {\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  background: white;\n  color: #333;\n  transition: all 0.2s ease;\n}\n\n.dark-mode .setting-item input {\n  background: #2d2d2d;\n  border-color: #555;\n  color: #f5f5f5;\n}\n\n.setting-item input:focus {\n  outline: none;\n  border-color: #0066cc;\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);\n}\n\n.dark-mode .setting-item input:focus {\n  border-color: #66ccff;\n  box-shadow: 0 0 0 3px rgba(102, 204, 255, 0.15);\n}\n\n.session-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.stat-item {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .stat-item {\n  background: #3d3d3d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.stat-item h4 {\n  color: #7f8c8d;\n  font-size: 0.9rem;\n  margin: 0 0 8px 0;\n  font-weight: 500;\n}\n\n.dark-mode .stat-item h4 {\n  color: #bbb;\n}\n\n.stat-item p {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n}\n\n.dark-mode .stat-item p {\n  color: #f5f5f5;\n}\n\n/* Break indicators */\n.break-indicator {\n  background: #e74c3c;\n  color: white;\n  padding: 6px 16px;\n  border-radius: 50px;\n  display: inline-block;\n  font-weight: 600;\n  font-size: 0.9rem;\n  margin-bottom: 16px;\n  box-shadow: 0 3px 6px rgba(231, 76, 60, 0.2);\n}\n\n.break-indicator.break {\n  background: #27ae60;\n  box-shadow: 0 3px 6px rgba(39, 174, 96, 0.2);\n}\n\n.dark-mode .break-indicator {\n  box-shadow: 0 3px 6px rgba(231, 76, 60, 0.3);\n}\n\n.dark-mode .break-indicator.break {\n  box-shadow: 0 3px 6px rgba(39, 174, 96, 0.3);\n}\n\n@media (max-width: 768px) {\n  .timer-display {\n    font-size: 4rem;\n    margin: 16px 0 32px;\n  }\n  \n  .timer-controls {\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .timer-button {\n    width: 100%;\n    max-width: 280px;\n  }\n  \n  .session-stats {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .setting-item label {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .pomodoro-container {\n    padding: 16px;\n  }\n  \n  .timer-display {\n    font-size: 3.5rem;\n    margin: 12px 0 24px;\n  }\n  \n  .pomodoro-container h2 {\n    font-size: 1.4rem;\n  }\n  \n  .timer-settings {\n    padding: 16px;\n  }\n  \n  .settings-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .stat-item p {\n    font-size: 1.5rem;\n  }\n}\n\n/* Subject Tracker Styles */\n.subject-tracker {\n  padding: 2rem;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.dark-mode .subject-tracker {\n  background: #1e1e1e;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.subject-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.subject-header h2 {\n  font-size: 2rem;\n  color: #2c3e50;\n  margin: 0;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .subject-header h2 {\n  color: #f5f5f5;\n}\n\n.add-subject-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background: #0066cc;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.3s ease;\n}\n\n.dark-mode .add-subject-button {\n  background: #1a75ff;\n}\n\n.add-subject-button:hover {\n  background: #0052a3;\n}\n\n.dark-mode .add-subject-button:hover {\n  background: #0052a3;\n}\n\n.subject-overview {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.subject-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.subject-list {\n  display: grid;\n  gap: 1rem;\n}\n\n.subject-card {\n  background: #fff;\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.dark-mode .subject-card {\n  background: #2d2d2d;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.subject-name {\n  font-size: 1.2rem;\n  color: #2c3e50;\n  margin-bottom: 1rem;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .subject-name {\n  color: #f5f5f5;\n}\n\n.progress-bar {\n  height: 8px;\n  background: #f0f0f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n  transition: background-color 0.3s ease;\n}\n\n.dark-mode .progress-bar {\n  background: #404040;\n}\n\n.progress-fill {\n  height: 100%;\n  transition: width 0.3s ease, background-color 0.3s ease;\n}\n\n.subject-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #7f8c8d;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .subject-meta {\n  color: #a0a0a0;\n}\n\n.subject-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.action-button {\n  padding: 0.5rem;\n  background: none;\n  border: none;\n  color: #3498db;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .action-button {\n  color: #5dade2;\n}\n\n.action-button:hover {\n  color: #2980b9;\n}\n\n.dark-mode .action-button:hover {\n  color: #3498db;\n}\n\n.subject-form {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.dark-mode .subject-form {\n  background: #2d2d2d;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #2c3e50;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .form-group label {\n  color: #f5f5f5;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: #fff;\n  color: #2c3e50;\n  transition: all 0.3s ease;\n}\n\n.dark-mode .form-group input,\n.dark-mode .form-group select {\n  background: #1e1e1e;\n  border-color: #444;\n  color: #f5f5f5;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  border-color: #0066cc;\n  outline: none;\n}\n\n.dark-mode .form-group input:focus,\n.dark-mode .form-group select:focus {\n  border-color: #1a75ff;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.submit-button,\n.cancel-button {\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.submit-button {\n  background: #0066cc;\n  color: white;\n  border: none;\n}\n\n.dark-mode .submit-button {\n  background: #1a75ff;\n}\n\n.submit-button:hover {\n  background: #0052a3;\n}\n\n.cancel-button {\n  background: none;\n  border: 1px solid #ddd;\n  color: #7f8c8d;\n}\n\n.dark-mode .cancel-button {\n  border-color: #444;\n  color: #a0a0a0;\n}\n\n.cancel-button:hover {\n  background: #f8f9fa;\n  border-color: #ccc;\n}\n\n.dark-mode .cancel-button:hover {\n  background: #2d2d2d;\n  border-color: #666;\n}\n\n/* Streak Tracker Styles */\n.streak-calendar {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 5px;\n  margin: 20px 0;\n}\n\n.calendar-day {\n  aspect-ratio: 1;\n  border-radius: 5px;\n  background: #eee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.calendar-day.active {\n  background: #28a745;\n  color: white;\n}\n\n/* Analytics Styles */\n.analytics-container {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.resource-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.resource-card {\n  background: white;\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  border: 1px solid #eee;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.dark-mode .resource-card {\n  background: #2d2d2d;\n  border-color: #333;\n}\n\n.resource-card:hover {\n  transform: translateY(-5px);\n}\n\n.dark-mode .resource-card:hover {\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);\n}\n\n/* Achievement Styles */\n.achievement-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 20px;\n}\n\n.achievement-card {\n  background: white;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  border: 1px solid #eee;\n}\n\n.dark-mode .achievement-card {\n  background: #2d2d2d;\n  border-color: #333;\n}\n\n.achievement-icon {\n  font-size: 2rem;\n  margin-bottom: 10px;\n  color: #ffc107;\n}\n\n.achievement-locked {\n  opacity: 0.5;\n}\n\n/* Responsive Design */\n@media (max-width: 992px) {\n  .study-tools-content {\n    flex-direction: column;\n    padding: 16px;\n  }\n  \n  .study-tools-sidebar {\n    width: 100%;\n    height: auto;\n    position: static;\n    margin-bottom: 20px;\n  }\n  \n  .study-tools-main {\n    min-height: auto;\n    padding: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .stat-card {\n    padding: 20px;\n  }\n  \n  .chart-container {\n    padding: 20px;\n    height: 250px;\n  }\n}\n\n@media (max-width: 480px) {\n  .study-tools-main {\n    padding: 16px;\n  }\n  \n  .stat-value {\n    font-size: 2rem;\n  }\n  \n  .user-welcome .user-avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n  \n  .user-welcome h3 {\n    font-size: 1.1rem;\n  }\n}\n\n/* Study Calendar Styles (Assuming it's part of Dashboard) */\n.study-calendar {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px; \n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .study-calendar {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.calendar-header h3 {\n  font-size: 1.2rem;\n  color: #333;\n  margin: 0;\n  font-weight: 600;\n}\n\n.dark-mode .calendar-header h3 {\n  color: #f5f5f5;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n}\n\n.calendar-day {\n  aspect-ratio: 1 / 0.8;\n  background: #f8f9fa;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  color: #666;\n  transition: all 0.2s ease;\n  padding: 4px;\n}\n\n.dark-mode .calendar-day {\n  background: #3d3d3d;\n  color: #aaa;\n}\n\n.day-number {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.day-hours {\n  font-size: 0.75rem;\n  color: #888;\n}\n\n.dark-mode .day-hours {\n  color: #999;\n}\n\n.calendar-day.studied {\n  background: rgba(40, 167, 69, 0.15);\n  border: 1px solid rgba(40, 167, 69, 0.3);\n  color: #1e7e34;\n}\n\n.dark-mode .calendar-day.studied {\n  background: rgba(46, 204, 113, 0.15);\n  border: 1px solid rgba(46, 204, 113, 0.3);\n  color: #2ecc71;\n}\n\n.calendar-day.studied .day-hours {\n  color: #218838;\n}\n\n.dark-mode .calendar-day.studied .day-hours {\n  color: #2ecc71;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
